export { default } from "./PremiumEmbeddingLicensePage";
